export default __webpack_public_path__ + "static/media/bQ.2baa6b58.svg";